// extracted by mini-css-extract-plugin
module.exports = {"socialLoginWrapper":"_2GXKc","socialLoginIframe":"IYyOt","ready":"_1RUKC","socialLoginIframeHorizontal":"iEPmB","unsupportedSocialAuthMessage":"_1tzMN"};